import React from 'react';
import VisitingClinicPage from './VisitingClinicPage';

const VisitingClinicSydney = () => (
  <VisitingClinicPage
    seo={{
      title: 'Autism, ADHD & Learning Assessments Sydney | Clinical Minds Psychology',
      description: 'Full neurodevelopmental assessments at regular visiting clinics in Sydney: autism, ADHD, FASD and learning disorders, children to adults. First appointment by Zoom, then one visit covers both assessment days. Enquire about upcoming clinic dates.',
      canonicalUrl: 'https://www.clinicalminds.net/visiting-clinics/sydney'
    }}
    location="Sydney"
    regionPhrase="Sydney and surrounds"
  />
);

export default VisitingClinicSydney;
